import { io, Socket } from 'socket.io-client'
import { SERVER_URL } from '../config'

class SocketService {
  private socket: Socket | null = null
  private reconnectAttempts = 0
  private maxReconnectAttempts = 5

  connect() {
    if (this.socket?.connected) {
      return this.socket
    }

    // An empty SERVER_URL means "same origin as this page", which is how the
    // nginx image serves it; socket.io-client expects undefined for that.
    this.socket = io(SERVER_URL || undefined, {
      autoConnect: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: this.maxReconnectAttempts,
      timeout: 20000,
    })

    this.socket.on('connect', () => {
      console.log('Connected to server')
      this.reconnectAttempts = 0
      // Join admin room to receive admin-specific events
      this.socket?.emit('join-admin')
    })

    this.socket.on('disconnect', () => {
      console.log('Disconnected from server')
    })

    this.socket.on('connect_error', (error) => {
      console.error('Socket connection error:', error)
      this.reconnectAttempts++
      
      if (this.reconnectAttempts >= this.maxReconnectAttempts) {
        console.error('Max reconnection attempts reached')
        this.disconnect()
      }
    })

    this.socket.on('reconnect', (attemptNumber) => {
      console.log('Reconnected to server after', attemptNumber, 'attempts')
      this.reconnectAttempts = 0
    })

    return this.socket
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect()
      this.socket = null
    }
  }

  getSocket(): Socket | null {
    return this.socket
  }

  isConnected(): boolean {
    return this.socket?.connected || false
  }

  // Event listeners
  onNewMessage(callback: (data: any) => void) {
    this.socket?.on('new_message', callback)
  }

  onNewConversation(callback: (data: any) => void) {
    this.socket?.on('new_conversation', callback)
  }

  onConversationEnd(callback: (data: any) => void) {
    this.socket?.on('conversation_ended', callback)
  }

  // Remove event listeners
  offNewMessage(callback?: (data: any) => void) {
    this.socket?.off('new_message', callback)
  }

  offNewConversation(callback?: (data: any) => void) {
    this.socket?.off('new_conversation', callback)
  }

  offConversationEnd(callback?: (data: any) => void) {
    this.socket?.off('conversation_ended', callback)
  }
}

export const socketService = new SocketService()
export default socketService